module.exports = __webpack_public_path__ + "static/media/galleryImage02.13628eb8.jpg";